import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { GetSectionByIdResponse } from '@twiliointernal/e2-commons-shared-definitions';

import { constants } from './definitions';
import { HelpCenterApiV2 } from '@twiliointernal/e2-commons-shared-api';

export const fetchSectionByIdFnKey = 'articles-by-section';

const helpCenterApi = new HelpCenterApiV2();

const fetchSectionById = async (
  sectionId: string,
): Promise<GetSectionByIdResponse> => {
  const { data, errorCode, success, message } =
    await helpCenterApi.getSectionById(sectionId);

  // Throwing error so that useQuery isError fails as expected.
  if (!success) {
    throw Error(`${errorCode}: ${message}`);
  }

  const section = data?.section ?? {};

  return { section };
};

export const useGetSectionById = ({
  sectionId,
}): UseQueryResult<GetSectionByIdResponse> => {
  const queryKey = [constants.fetchSectionByIdFnKey, sectionId];

  return useQuery({
    queryKey,
    queryFn: () => fetchSectionById(sectionId),
    retry: false,
  });
};

export default useGetSectionById;
